import { cx } from '@emotion/css';
import type { FC } from 'react';

import {
  footerSocialContainerCss,
  footerSocialContainerOffsetCss,
  footerSocialCss,
  footerSocialIconsWrapperCss,
  wrapperCss,
} from './styles';
import type { FooterSocialProps } from './types';

export const FooterSocial: FC<FooterSocialProps> = ({ title, hasSideNav, children }) => {
  return (
    <section data-testid="footer-social" className={wrapperCss}>
      <div
        className={cx(footerSocialContainerCss, { [footerSocialContainerOffsetCss]: hasSideNav })}
      >
        <div className={footerSocialCss}>
          {title && <h5>{title}</h5>}
          <div className={footerSocialIconsWrapperCss}>{children}</div>
        </div>
      </div>
    </section>
  );
};
